<div class="p-4 flex flex-col items-center overflow-hidden">
    <h1 class="font-bold text-center my-4">Confirme creacion</h1>
    <div class="flex flex-col mb-4 mx-4">
      <span>¿Esta seguro que desea crear la transaccion?</span>
    </div>
    <div class="flex flex-col mx-4 max-w-[100%]">
      <div class="flex-col md:flex-row">
        <span class=""><b>Cliente: </b> </span>
        <span class="md:mx-1"> {{this.data.nombre}}</span>
      </div>
      <div class="flex-col md:flex-row">
        <span class=""><b>Id: </b> </span>
        <span class="md:mx-1"> {{this.data.userid}}</span>
      </div>
      <div class="flex-col break-words md:flex-row overflow-hidden">
        <span class=""><b>Wallet: </b> </span>
        <span class="break-words md:mx-1"> {{this.data.formData.walletTrx}}</span>
      </div>
      <div class="flex-col md:flex-row">
        <span class=""><b>Tasa: </b> </span>
        <span class="md:mx-1"> {{this.data.formData.tasa | number:'1.2-2'}}</span>
      </div>
      <div class="flex-col md:flex-row">
        <span class=""><b>Monto promesa: </b> </span>
        <span class="md:mx-1"> {{this.data.formData.totalEnvio | currency:'USD':'symbol':'1.2-2'}} {{ this.data.formData.monedaLocal}}</span>
      </div>
    </div>
    <div mat-dialog-actions class="place-content-center">
      <button [mat-dialog-close]="true" class="m-4 shadow max-h-md"
        style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">Si</button>
      <button [mat-dialog-close]="false" class="m-4 shadow max-h-md"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">No</button>
    </div>
</div>
